import { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import AdminLogin from "../components/AdminDashboard/AdminLogin";
import NewsletterSection from "../components/AdminDashboard/NewsletterSubscribers";
import ContactSection from "../components/AdminDashboard/ContactSubmissions";
import CreateBlogForm from "../components/AdminDashboard/CreateBlogForm";
import ManageBlogs from "../components/AdminDashboard/ManageBlogs";
import BannerSettings from "../components/AdminDashboard/BannerSettings";
import JobPosting from "../components/AdminDashboard/JobPosting";
import JobOffline from "../components/AdminDashboard/JobOffline";
import JobApplicants from "../components/AdminDashboard/JobApplicants";
import JobDetails from "../components/AdminDashboard/JobDetails";
import BlogEmails from "../components/AdminDashboard/BlogEmails";


export default function AdminPage() {
  const [token, setToken] = useState(null);
  const [section, setSection] = useState("newsletter");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  // Verify token on mount
  useEffect(() => {
    const verifyToken = async () => {
      const storedToken = localStorage.getItem("token");

      if (!storedToken) {
        setLoading(false);
        return;
      }

      try {
        await axios.get(`${API_BASE}verify-token`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });
        setToken(storedToken);
      } catch (error) {
        console.error("Token verification failed:", error);
        localStorage.removeItem("token");
        setToken(null);
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, []);

  // Show loading state while verifying token
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-xl font-semibold text-gray-600">Verifying...</div>
      </div>
    );
  }

  // Show login screen if not authenticated
  if (!token) {
    return <AdminLogin onAuthenticated={(t) => {
      setToken(t);
      localStorage.setItem("token", t); // Save token on login
    }} />;
  }
  
  // Handle section changes
  const handleSectionChange = (sectionName) => {
    setSection(sectionName);
    navigate("/admin");
  };

  return (
    <div className="min-h-[calc(100vh-120px)] flex bg-gray-100">
      {/* Sidebar */}
      <aside className="w-64 bg-white shadow-md p-6 flex flex-col justify-between">
        <div>
          <h1 className="text-2xl font-bold text-blue-700 mb-6">
            Think41 Admin
          </h1>
          <nav className="space-y-3">
            <button
              onClick={() => handleSectionChange("newsletter")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Newsletter Subscribers
            </button>
            <button
              onClick={() => handleSectionChange("contact")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Contact Submissions
            </button>
            <button
              onClick={() => handleSectionChange("blog")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Create Blog
            </button>
            <button
              onClick={() => handleSectionChange("manage_blogs")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Manage Blogs
            </button>
            <button
              onClick={() => handleSectionChange("blog_emails")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Blog Emails
            </button>
            <button
              onClick={() => handleSectionChange("banner")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Banner Settings
            </button>

             <button
              onClick={() => handleSectionChange("job")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Job Posting
            </button>

              <button
              onClick={() => handleSectionChange("job_offline")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Job Offline
            </button>

            <button
              onClick={() => handleSectionChange("job_applicants")}
              className="block w-full text-left px-3 py-2 rounded hover:bg-blue-100 font-medium cursor-pointer"
            >
              Job Applicants
            </button>
          </nav>
        </div>
        <button
          onClick={() => {
            setToken(null);
            localStorage.removeItem("token");
          }}
          className="mt-8 text-white font-semibold bg-red-600 hover:bg-red-800 py-2 rounded-xl cursor-pointer"
        >
          Logout
        </button>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-8">
        <Routes>
          <Route path="/jobs/:jobId" element={<JobDetails />} />
          <Route path="/" element={
            <>
              {section === "newsletter" && <NewsletterSection />}
              {section === "contact" && <ContactSection />}
              {section === "blog" && <CreateBlogForm />}
              {section === "manage_blogs" && <ManageBlogs />}
              {section === "blog_emails" && <BlogEmails />}
              {section === "banner" && <BannerSettings />}
              {section === "job" && <JobPosting />}
              {section === "job_offline" && <JobOffline />}
              {section === "job_applicants" && <JobApplicants />}
            </>
          } />
        </Routes>
      </main>
    </div>
  );
}
